export default "__VITE_ASSET__ILCbzIRs__"